import React from 'react';
import { Stack } from '@mantine/core';
import { NavLink } from '@mantine/core';
import {
  IconHome,
  IconBuilding,
  IconCreditCard,
  IconSettings
} from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { CUSTOMER_ROUTES } from '../../routing/routes';

/**
 * CustomerNavbar Component
 *
 * Limited navigation sidebar for customer users with links to:
 * - Home (My Mentions) - Primary landing page
 * - My Business
 * - Billing
 * - Settings
 *
 * Sprint 037 Session 9: Removed separate Dashboard link - My Mentions is now the home page
 */
export const CustomerNavbar: React.FC = (): React.ReactElement => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string): boolean => {
    // Sprint 037 Session 9: Handle '/' and '/mentions' as the same route
    if (path === CUSTOMER_ROUTES.MENTIONS) {
      return location.pathname === '/' || location.pathname === '/mentions' || location.pathname.startsWith('/mentions/');
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const handleNavigate = (path: string): void => {
    navigate(path);
  };

  return (
    <Stack gap="xs" p="md">
      {/* Sprint 037 Session 9: My Mentions is now the home page */}
      <NavLink
        label="Home"
        leftSection={<IconHome size={20} stroke={1.5} />}
        active={isActive(CUSTOMER_ROUTES.MENTIONS)}
        onClick={(): void => handleNavigate(CUSTOMER_ROUTES.MENTIONS)}
        variant="subtle"
      />

      <NavLink
        label="My Business"
        leftSection={<IconBuilding size={20} stroke={1.5} />}
        active={isActive(CUSTOMER_ROUTES.MY_BUSINESS)}
        onClick={(): void => handleNavigate(CUSTOMER_ROUTES.MY_BUSINESS)}
        variant="subtle"
      />

      <NavLink
        label="Billing"
        leftSection={<IconCreditCard size={20} stroke={1.5} />}
        active={isActive(CUSTOMER_ROUTES.BILLING)}
        onClick={(): void => handleNavigate(CUSTOMER_ROUTES.BILLING)}
        variant="subtle"
      />

      {/* SESSION_201: Settings link */}
      <NavLink
        label="Settings"
        leftSection={<IconSettings size={20} stroke={1.5} />}
        active={isActive(CUSTOMER_ROUTES.SETTINGS)}
        onClick={(): void => handleNavigate(CUSTOMER_ROUTES.SETTINGS)}
        variant="subtle"
      />
    </Stack>
  );
};
